/** 供应链 路由 **/

import Layout from "@/views/layout/Layout";

const supplyAssetRouter = {
  path: "/supplyAssetMan",
  component: Layout,
  name: "supplyAssetMan",
  meta: {
    title: "固定资产",
    icon: "fixedAssets",
    roles: ["zc_gongyinglian"]
  },
  alwaysShow: true,
  children: [
    {
      path: "purchasingMan",
      component: () => import("@/views/supplyAssetMan/purchasingMan/index"),
      meta: {
        title: "采购管理",
        roles: ["zc_caigouguanli"]
      },
      alwaysShow: true,
      children: [
        {
          path: "purchasingPlan",
          component: () =>
            import("@/views/supplyAssetMan/purchasingMan/purchasingPlan/index"),
          name: "采购计划",
          meta: {
            title: "采购计划",
            roles: ["zc_caigoujihua"]
          }
        },
        {
          path: "purchasingInquiry",
          component: () =>
            import(
              "@/views/supplyAssetMan/purchasingMan/purchasingInquiry/index"
            ),
          name: "采购询价",
          meta: {
            title: "采购询价",
            roles: ["zc_caigouxunjia"]
          }
        },
        {
          path: "purchasingBill",
          component: () =>
            import("@/views/supplyAssetMan/purchasingMan/purchasingBill/index"),
          name: "采购单",
          meta: {
            title: "采购单",
            roles: ["zc_caigoudan"]
          }
        },
        {
          path: "arrivalNotice",
          component: () =>
            import("@/views/supplyAssetMan/purchasingMan/arrivalNotice/index"),
          name: "到货通知",
          meta: {
            title: "到货通知",
            roles: ["zc_daohuotongzhi"]
          }
        },
        {
          path: "returnGoods",
          component: () =>
            import("@/views/supplyAssetMan/purchasingMan/returnGoods"),
          name: "退货处理",
          meta: {
            title: "退货处理",
            roles: ["zc_daohuotongzhi"]
          }
        }
      ]
    },
    {
      path: "reservoirMan",
      component: () => import("@/views/supplyAssetMan/reservoirMan/index"),
      meta: {
        title: "库房管理",
        roles: ["zc_kufangguanli"]
      },
      alwaysShow: true,
      children: [
        {
          path: "inStockCheck",
          component: () =>
            import("@/views/supplyAssetMan/reservoirMan/inStockCheck"),
          name: "入库验收",
          meta: {
            title: "入库验收",
            roles: ["zc_rukuyanshou"]
          }
        },
        {
          path: "inStockMan",
          component: () =>
            import("@/views/supplyAssetMan/reservoirMan/inStockMan"),
          name: "入库管理",
          meta: {
            title: "入库管理",
            roles: ["zc_rukuguanli"]
          }
        },
        {
          path: "outStockMan",
          component: () =>
            import("@/views/supplyAssetMan/reservoirMan/outStockMan/index"),
          name: "出库管理",
          meta: {
            title: "出库管理",
            roles: ["zc_chukuguanli"]
          }
        },
        {
          path: "returnRequest",
          component: () =>
            import("@/views/supplyAssetMan/reservoirMan/returnRequest"),
          name: "退货申请",
          meta: {
            title: "退货申请",
            roles: ["zc_chukuguanli"]
          }
        },
      ]
    },
    {
      path: "acceptance",
      component: () =>
        import("@/views/supplyAssetMan/reservoirMan/acceptance"),
      name: "到货验收",
      meta: {
        title: "到货验收",
        roles: ["zc_daohuoyanshou"]
      }
    },
    {
      path: "assetsReceive",
      component: () => import("@/views/supplyAssetMan/assetsReceive/index"),
      name: "资产接收",
      meta: {
        title: "资产接收",
        roles: ["zc_zichanjieshou"]
      },
    },
    {
      path: "assetsReturn",
      component: () => import("@/views/supplyAssetMan/assetsReturn/index"),
      name: "资产返库",
      meta: {
        title: "资产返库",
        roles: ["zc_zichanfanku"]
      },
    },
    {
      path: "assetsCompensate",
      component: () => import("@/views/supplyAssetMan/assetsCompensate/index"),
      name: "资产赔偿",
      meta: {
        title: "资产赔偿",
        roles: ["zc_zichanpeichang"]
      },
    },
    {
      path: "assetsLiquidationInquire",
      component: () => import("@/views/supplyAssetMan/assetsLiquidationInquire/index"),
      name: "资产清减",
      meta: {
        title: "资产清减",
        roles: ["zc_zichanqingjian"]
      },
    },
    {
      path: "assetsInventory",
      component: () => import("@/views/supplyAssetMan/assetsInventory/index"),
      name: "盘点管理",
      meta: {
        title: "盘点管理",
        roles: ["zc_pandianguanli"]
      },
    },
    {
      path: "assetsMan",
      component: () => import("@/views/supplyChainMan/assetsMan/index"),
      meta: {
        title: "资产管理",
        roles: ["zichanguanli"]
      },
      alwaysShow: true,
      children: [
        // {
        //   path: "materialInventory",
        //   component: () =>
        //     import("@/views/supplyChainMan/assetsMan/materialInventory/index"),
        //   name: "可盘查盘点管理",
        //   meta: {
        //     title: "可盘查盘点管理",
        //     roles: ["kepanchapandianguanli"]
        //   }
        // },

        // {
        //   path: "scrapDisposal",
        //   component: () =>
        //     import("@/views/supplyChainMan/assetsMan/scrapDisposal"),
        //   name: "可盘查报废处理",
        //   meta: {
        //     title: "可盘查报废处理",
        //     roles: ["kepanchabaofeichuli"]
        //   }
        // },
        // {
        //   path: "scrapAuth",
        //   component: () => import("@/views/supplyChainMan/assetsMan/scrapAuth"),
        //   name: "可盘查报废审核",
        //   meta: {
        //     title: "可盘查报废审核",
        //     roles: ["kepanchabaofeishenhe"]
        //   }
        // },
        // {
        //   path: "scrapSelling",
        //   component: () =>
        //     import("@/views/supplyChainMan/assetsMan/scrapSelling"),
        //   name: "可盘查报废变卖",
        //   meta: {
        //     title: "可盘查报废变卖",
        //     roles: ["kepanchabaofeibianmai"]
        //   }
        // },
        // {
        //   path: "assetsManInventory",
        //   component: () =>
        //     import("@/views/supplyChainMan/assetsMan/assetsManInventory"),
        //   name: "资产盘点管理",
        //   meta: {
        //     title: "资产盘点管理",
        //     roles: ["zichanpandianguanli"]
        //   }
        // },
        // {
        //   path: "assetsLossSend",
        //   component: () =>
        //     import("@/views/supplyChainMan/assetsMan/assetsLossSend"),
        //   name: "资产丢失申请",
        //   meta: {
        //     title: "资产丢失申请",
        //     roles: ["zichandiushishenqing"]
        //   }
        // },
        // {
        //   path: "assetsLossProcessing",
        //   component: () =>
        //     import("@/views/supplyChainMan/assetsMan/assetsLossProcessing"),
        //   name: "资产丢失处理",
        //   meta: {
        //     title: "资产丢失处理",
        //     roles: ["zichandiushichuli"]
        //   }
        // },
        {
          path: "assetsList",
          component: () =>
            import("@/views/supplyChainMan/assetsMan/assetsList"),
          name: "固定资产台账",
          meta: {
            title: "固定资产台账",
            roles: ["gudingzichantaizhang"]
          }
        }
      ]
    },

    {
      path: "invalidQuery",
      component: () => import("@/views/supplyAssetMan/invalidQuery/index"),
      name: "作废查询",
      meta: {
        title: "作废查询",
        roles: ["zc_zuofeichaxun"]
      },
    },
    {
      path: "assetMain",
      component: () => import("@/views/supplyAssetMan/assetMain/index"),
      name: "资产维修",
      meta: {
        title: "资产维修",
        roles: ["zc_zichanweixiu"]
      },
    },
  ]
};

export default supplyAssetRouter;
